'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _roles = require('config/permissions/roles');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdverseEventsService = function () {
  function AdverseEventsService($http) {
    'ngInject';

    _classCallCheck(this, AdverseEventsService);

    this.$http = $http;
  }

  _createClass(AdverseEventsService, [{
    key: 'setQuery',
    value: function setQuery(query) {
      this.query = query;
    }
  }, {
    key: 'getAdverseEvents',
    value: function getAdverseEvents() {
      return this.$http.get('/api/ae/list', {
        params: _extends({}, this.query)
      });
    }
  }, {
    key: 'getAdverseEventsByReportDate',
    value: function getAdverseEventsByReportDate(reportDate) {
      return this.$http.get('/api/ae/search_by_report_date', {
        params: _extends({}, this.query, {
          reportDate: reportDate.toISOString()
        })
      });
    }
  }, {
    key: 'getAdverseEventsByProduct',
    value: function getAdverseEventsByProduct(productId) {
      return this.$http.get('/api/ae/search_by_product', {
        params: _extends({}, this.query, {
          productId: productId
        })
      });
    }
  }, {
    key: 'getAdverseEventsByMember',
    value: function getAdverseEventsByMember(memberId) {
      return this.$http.get('/api/ae/search_by_member', {
        params: _extends({}, this.query, {
          memberId: memberId
        })
      });
    }
  }, {
    key: 'getAdverseEventsByIngredient',
    value: function getAdverseEventsByIngredient(ingredientId) {
      return this.$http.get('/api/ae/search_by_user_ingredient', {
        params: _extends({}, this.query, {
          userIngredientId: ingredientId
        })
      });
    }
  }, {
    key: 'getAdverseEventsBySystemIngredient',
    value: function getAdverseEventsBySystemIngredient(systemIngredientId) {
      return this.$http.get('/api/ae/search_by_system_ingredient', {
        params: _extends({}, this.query, {
          systemIngredientId: systemIngredientId
        })
      });
    }
  }, {
    key: 'getAdverseEventsByType',
    value: function getAdverseEventsByType(selectedSymptoms, shouldMatchAll) {
      var url = shouldMatchAll ? 'search_by_all_symptom' : 'search_by_any_symptom';

      return this.$http.get('/api/ae/' + url, {
        params: _extends({}, this.query, {
          selectedSymptoms: selectedSymptoms
        })
      });
    }
  }, {
    key: 'getAdverseEventsBySpecies',
    value: function getAdverseEventsBySpecies(species) {
      return this.$http.get('/api/ae/search_by_species', {
        params: _extends({}, this.query, {
          selectedSpecies: species
        })
      });
    }
  }, {
    key: 'getAdverseEventsMissingInfo',
    value: function getAdverseEventsMissingInfo() {
      return this.$http.get('/api/ae/search_by_missing_info', {
        params: _extends({}, this.query)
      });
    }
  }, {
    key: 'getAdverseEventsByText',
    value: function getAdverseEventsByText(text) {
      return this.$http.get('/api/ae/search_by_text', {
        params: _extends({}, this.query, {
          searchText: text
        })
      });
    }
  }, {
    key: 'getAdverseEventsByStatus',
    value: function getAdverseEventsByStatus(status) {
      return this.$http.get('/api/ae/search_by_status', {
        params: _extends({}, this.query, {
          status: status
        })
      });
    }
  }, {
    key: 'getEventTypes',
    value: function getEventTypes() {
      return [{
        name: 'Diarrhea',
        id: 0
      }, {
        name: 'Stomach Upset/Vomiting',
        id: 1
      }, {
        name: 'Colic (Horse)',
        id: 2
      }, {
        name: 'Skin/Allergic Reaction',
        id: 3
      }, {
        name: 'Seizures',
        id: 4
      }, {
        name: 'Death',
        id: 5
      }, {
        name: 'Lameness',
        id: 6
      }, {
        name: 'Accidental Ingestion',
        id: 7
      }, {
        name: 'Other',
        id: 8
      }];
    }
  }, {
    key: 'getSearchTypes',
    value: function getSearchTypes() {
      return [{
        name: 'All Adverse Events',
        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.REGULATOR, '' + _roles.SYS_ADMIN]
      }, {
        name: 'Open Adverse Events',
        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.REGULATOR, '' + _roles.SYS_ADMIN]
      }, {
        name: 'Search by Report Date',
        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.REGULATOR, '' + _roles.SYS_ADMIN]
      }, {
        name: 'Search by Product Name',
        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.REGULATOR, '' + _roles.SYS_ADMIN]
      }, {
        name: 'Search by Ingredient Name',
        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.REGULATOR, '' + _roles.SYS_ADMIN]
      }, {
        name: 'Search by System Ingredient',
        permission: ['' + _roles.REGULATOR, '' + _roles.SYS_ADMIN]
      }, {
        name: 'Search by Event (any events)',
        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.REGULATOR, '' + _roles.SYS_ADMIN]
      }, {
        name: 'Search by Event (all matched events)',
        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.REGULATOR, '' + _roles.SYS_ADMIN]
      }, {
        name: 'Search by Member',
        permission: ['' + _roles.SYS_ADMIN, '' + _roles.REGULATOR]
      }, {
        name: 'Search by Species',
        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.REGULATOR, '' + _roles.SYS_ADMIN]
      }, {
        name: 'Search by Text',
        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.REGULATOR, '' + _roles.SYS_ADMIN]
        // }, {
        //   name: 'Missing Event Information',
        //   permission: [`${USER}`, `${COMPANY_ADMIN}`, `${REGULATOR}`, `${SYS_ADMIN}`]
      }];
    }
  }, {
    key: 'getAlerts',
    value: function getAlerts() {
      return this.$http.get('/api/alert/load_alert_ae');
    }
  }, {
    key: 'getOpenAdverseEventsPreviousMonth',
    value: function getOpenAdverseEventsPreviousMonth() {
      return this.$http.get('/api/ae/previous_month');
    }
  }]);

  return AdverseEventsService;
}();

exports.default = AdverseEventsService;


// WEBPACK FOOTER //
// ./services/adverse-events.service.js